<template> 

    <div>
        
        <div v-if="loading">

            <ring-loader/>
        </div>
        <div v-else>

            <public-sessions :mySlot="sessionsList" :slotsCategoriesOptions="category"/>
        </div>
        <!-- <div>

            <label>Sessions</label>
        </div>

        <div>

            <div v-for="(oneSession, index) in sessionsList" :key="index" class="mt-2">
            
                <public-sessions-card :mySession="oneSession"/>
            </div>
        </div> -->

    </div>
</template>

<script> 

import axios from '@/classes/myAxios'
import { RingLoader } from 'vue-spinners-css';

import publicSessionsCard from './PublicSessionsCard.vue';
import PublicSessions from './PublicSessions.vue';

import componentsHelpers from '../../classes/componentHelpers';

    export default {

       async mounted(){


            // console.log(`in public info sessions`);

            await this.loadData();

            let result = await this.$auth.isAuthenticated();
            
            // console.log(`result: ${result}`);

            if(result == true){

                this.$router.push({ path: 'sessions' })
            }
        },

        props:{

            isFromBusinessPage: false,
            myBusinessId: 0,
        },

        components:{

            publicSessionsCard,
                PublicSessions,
                RingLoader
        },

        methods:{

            async loadData(){

                this.loading = true;
                let result;

                try{

                    if(this.isFromBusinessPage){

                        result = await axios({method: 'post',url: '/pnadiapi/forPublicInfo/getSessionsWithId',
                            data: {
                            
                                businessId: this.myBusinessId,
                            }
                        });
                    }else{
                        
                        result = await axios({method: 'post',url: '/pnadiapi/forPublicInfo/getSessions',
                            data: {
                            
                            }
                        });
                    }
                    

                    // console.log(`result.data.length: ${JSON.stringify(result.data.slot.length)}`);

                    this.category = result.data.category;

                    // console.log(`category: ${JSON.stringify(result.data.category)}`)

                    this.sessionsList = result.data.slot;

                    this.loading = false;

                }catch(error){

                    componentsHelpers.sendError(this.$apollo, 0,'home', 'publicInfoSessions', 'loadData', error);

                    componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

                    this.loading = false;
                }
            }
        },

        data(){

            return{

                sessionsList: [],
                category: [],
                loading: false,
            }
        }
     }
</script>

<style>

</style>